import { render, staticRenderFns } from "./BottomDrawer.vue?vue&type=template&id=028b1028&scoped=true&"
import script from "./BottomDrawer.vue?vue&type=script&lang=js&"
export * from "./BottomDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BottomDrawer.vue?vue&type=style&index=0&id=028b1028&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b1028",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDivider,VIcon,VToolbar})
